<template>
    <div v-if="loading">Loading....</div>

    <div
        v-else-if="
            splashData &&
            splashData.title &&
            splashData.content &&
            splashData.welcome_page_banner_image_url
        "
        class="dm-splash-screen-wrap"
        :style="backgroundImageStyleDynamic"
    >
        <div class="dm-splash-screen">
            <div class="text-center py-12">
                <h2 class="mb-6 px-5">{{ splashData.title }}</h2>

                <div
                    class="text-left dm-splash-screen-content my-20 px-5 font-size-h5"
                    v-html="splashData.content"
                ></div>

                <button
                    class="btn btn-lg btn-success px-10 py-3 font-weight-bold font-size-h5"
                    @click="goToStep('genres')"
                >
                    {{ translate("Start!") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyId: companyId, // Must exist in DOM
            entryPointId: entryPointId, // Must exist in DOM

            splashData: {
                title: "",
                content: "",
                welcome_page_banner_image_url: "",
            },

            loading: false,
        };
    },

    computed: {
        backgroundImageStyleDynamic() {
            return (
                "background-image: url(" +
                this.splashData.welcome_page_banner_image_url +
                ");"
            );
        },
    },

    methods: {
        loadSplashPageContent() {
            var self = this;
            axios
                .get("/api/sw/splash-page-content/" + this.entryPointId)
                .then(function (response) {
                    self.loading = false;
                    self.splashData = response.data;
                });
        },

        goToStep(stepIndex) {
            this.$router.push({ name: "genres" });
        },
    },

    mounted() {
        this.loading = true;
        this.loadSplashPageContent();
    },
};
</script>
